<template>
  <div>
    <b-button
      v-ripple.400="'rgba(113, 102, 240, 0.15)'"
      v-b-modal.modal-direccion
      block
      variant="relief-primary"
      class="btn-icon"
    >
      <feather-icon icon="EditIcon" />
      <!-- Editar -->
    </b-button>

    <b-modal
      id="modal-direccion"
      ok-title="guardar datos"
      ok-variant="relief-success"
      cancel-title="cancelar"
      cancel-variant="relief-danger"
      centered
      size="lg"
      title="Actualuizar Dirección"
      @ok="validationForm"
    >
      <b-row>
        <b-col cols="12">
          <b-alert
            :show="status"
            variant="primary"
          >
            <div class="alert-body">
              <feather-icon
                class="mr-25"
                icon="AlertTriangleIcon"
              />
              <span
                class="ml-25"
              >Por favor, verifica que los datos son correctos.
              </span>
            </div>
          </b-alert>
        </b-col>

        <b-col cols="12">
          <b-form-group label="Busca tu dirección">
            <autocomplete
              class="mb-1"
              @result-search="setValuesDirection"
              @clean-data="cleanDataDirection"
            />
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <validation-observer ref="formDireccionUpdate">
            <b-form>
              <b-row>
                <b-col cols="6">
                  <b-form-group label="Entidad Federativa">
                    <validation-provider
                      #default="{ errors }"
                      name="Entidad Federativa"
                      rules="alpha_spaces|required"
                    >
                      <b-form-input
                        v-model="newD.entidad_federativa"
                        :state="errors.length > 0 ? false : null"
                        placeholder="Entidad Federativa"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col cols="6">
                  <b-form-group label="Alcaldía">
                    <validation-provider
                      #default="{ errors }"
                      name="Alcaldía"
                      rules="alpha_spaces|required"
                    >
                      <b-form-input
                        v-model="newD.alcaldia"
                        :state="errors.length > 0 ? false : null"
                        placeholder="Alcaldía"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col cols="6">
                  <b-form-group label="Colonia">
                    <validation-provider
                      #default="{ errors }"
                      name="Colonia"
                      rules="alpha_spaces|required"
                    >
                      <b-form-input
                        v-model="newD.colonia"
                        :state="errors.length > 0 ? false : null"
                        placeholder="Colonia"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col cols="6">
                  <b-form-group label="Código Postal">
                    <validation-provider
                      #default="{ errors }"
                      name="Código Postal"
                      rules="digits:5|required"
                    >
                      <b-form-input
                        v-model="newD.codigo_postal"
                        :state="errors.length > 0 ? false : null"
                        placeholder="Código Postal"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col cols="6">
                  <b-form-group label="Calle">
                    <validation-provider
                      #default="{ errors }"
                      name="Calle"
                      :rules="{ required: true, regex: /^[A-Z0-9_ ]+$/ }"
                    >
                      <b-form-input
                        v-model="newD.calle"
                        :state="errors.length > 0 ? false : null"
                        placeholder="Calle"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col cols="6">
                  <b-form-group label="Núm. Exterior">
                    <validation-provider
                      #default="{ errors }"
                      name="Núm. Exterior"
                      rules="alpha_num|max:5|required"
                    >
                      <b-form-input
                        v-model="newD.numero_exterior"
                        :state="errors.length > 0 ? false : null"
                        placeholder="Núm. Exterior"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col cols="6">
                  <b-form-group label="Núm. Interior">
                    <validation-provider
                      #default="{ errors }"
                      name="Núm. Interior"
                      rules="alpha_num|max:5"
                    >
                      <b-form-input
                        v-model="newD.numero_interior"
                        :state="errors.length > 0 ? false : null"
                        placeholder="Núm. Interior"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-form>
          </validation-observer>
        </b-col>
      </b-row>

      <!-- <b-card-text>Biscuit chocolate cake gummies. Lollipop I love macaroon bear claw
        caramels. I love marshmallow tiramisu I love fruitcake I love gummi
        bears. Carrot cake topping liquorice. Pudding caramels liquorice sweet I
        love. Donut powder cupcake ice cream tootsie roll jelly.</b-card-text> -->
    </b-modal>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BAlert,
  BButton,
  BCol,
  BFormInput,
  BFormGroup,
  BForm,
  BModal,
  VBModal,
  BRow,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import Autocomplete from '@/views/registro/components/components/AutocompleteDireccion.vue'
import PrebecarioService from '@/services/PrebecariosService'

export default {
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
  components: {
    BAlert,
    BButton,
    BCol,
    BFormInput,
    BFormGroup,
    BForm,
    BModal,
    BRow,
    ValidationObserver,
    ValidationProvider,
    Autocomplete,
  },
  props: {
    id: {
      type: [Number, String],
      required: true,
    },
    current: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      newD: null,
      status: false,
    }
  },
  computed: {},
  mounted() {
    this.newD = { ...this.current }
  },
  methods: {
    setValuesDirection(address) {
      const { newD } = this
      newD.entidad_federativa = address.state.toUpperCase()
      newD.alcaldia = address.city.toUpperCase()
      newD.colonia = address.district.toUpperCase()
      newD.codigo_postal = address.postalCode
      newD.calle = address.street.toUpperCase()
      newD.numero_exterior = address.houseNumber
    },
    cleanDataDirection() {
      const { newD } = this
      newD.entidad_federativa = ''
      newD.alcaldia = ''
      newD.colonia = ''
      newD.codigo_postal = ''
      newD.calle = ''
      newD.numero_exterior = ''
    },
    msg({ title, text, icon }) {
      return this.$swal({
        title,
        text,
        icon,
        customClass: {
          confirmButton: 'btn btn-primary',
        },
        buttonsStyling: false,
      })
    },
    validationForm(bvModalEvt) {
      bvModalEvt.preventDefault()
      this.$refs.formDireccionUpdate.validate().then(success => {
        if (success) {
          this.status = false
          this.saveDirection()
        } else {
          this.status = true
        }
      })
    },
    saveDirection() {
      PrebecarioService.updateDireccion(this.id, this.newD)
        .then(resp => {
          if (resp.status === 200) {
            this.$bvModal.hide('modal-direccion')
            this.$emit('update', this.newD)
            this.msg({
              title: 'OK!',
              text: 'Datos actualizados correctamente!',
              icon: 'success',
            })
          }
        })
        .catch(() => {
          this.msg({
            title: 'Error!',
            text: 'Lo sentimos algo salio mal!',
            icon: 'danger',
          })
        })
    },
  },
}
</script>

<style lang="scss" scoped>
pre {
  min-height: 295px;
  padding: 1.5rem;
  margin-bottom: 0;
  border-radius: 0.5rem;
}
</style>
